"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const loginTranslations = {
    loginInfoMessage: "Login to streamline collaboration",
    titleLogin: "Please login to your account",
    emailText: "Email Address",
    incorrectEmailPassword: "Incorrect email or password",
    emailError: "Please enter a valid email address",
    loginBtnText: "Login",
    forgotPassword: "Forgot password?",
    forgotPasswordHeaderText: "Forgot password",
    passwordText: "Password",
    passwordError: "Please enter a valid password",
    termsAndConditionsMessage: "By logging in, you agree to the",
    termsAndConditions: "Terms & Conditions",
    privacyPolicy: "Privacy Policy",
    and: "and",
    forgotPasswordInfoMessage: "To reset your password, enter your registered email address",
    forgotPasswordCodeInfoMessage: "A 6-digit code will be sent to this email address",
    codeSentMessage: "6-digit code has been sent to your email",
    sessionChangedTitle: "Session changed",
    sessionChangedMessage: "Your session was updated in another tab. Click reload to continue.",
    sessionChangedReload: "Reload",
};
exports.default = loginTranslations;
